import { where, getDocs, query, collection } from "firebase/firestore";
import { db } from "../firebase";

async function getOrgOptionsCategories(orgId) {
  try {
    const optionsCategoriesRef = collection(db, "OptionCategories");
    const querySnapshot = await getDocs(query(optionsCategoriesRef, where("orgId", "==", orgId)));
    const optionsCategories = querySnapshot.docs.map((doc) => doc.data());
    return optionsCategories;
  } catch (error) {
    console.error(error);
  }
}

export default getOrgOptionsCategories;
